import "./style.css";
import { useState, useRef } from "react";

export default function BusinessIndustrySelect({
    chooseFileHandler,
    onChange,
    file,
    name = "",
    desc,
    buttonLabel,
    isInvalid = false,
    invalidMessage = "",
    innerRef,
    id,
    accept,
    onRemove,
    selectedFile,
    preview
}) {
    const formatFileSize = (bytes) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const sizes = ["Bytes", "KB", "MB", "GB"]
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
    }

    return (
        <div className="container border-dashsed bg-grey-light mb-3">
            <div className="my-5">
                <div className="d-flex align-items-center justify-content-center">
                    {selectedFile ? (
                        <div>
                            {/* Image Preview */}
                            {preview && (
                                <div className="d-flex align-items-center justify-content-center position-relative mb-3">
                                    <img
                                        src={preview || "/placeholder.svg"}
                                        alt="Preview"
                                        className="img-fluid rounded shadow-sm p-2 preview-selected-file"
                                    />
                                </div>
                            )}

                            {/* File Info Card */}
                            <div className="card mb-3">
                                <div className="card-body p-3">
                                    <div className="d-flex align-items-center">
                                        <div className="me-3">
                                            {selectedFile.type === "application/pdf" ? (
                                                <i className="fas fa-file-pdf pdf-preview-file fs-4" aria-hidden="true"></i>
                                            ) : (
                                                <i className="fas fa-image image-preview-file fs-4" aria-hidden="true"></i>
                                            )}
                                        </div>
                                        <div className="flex-grow-1 text-start me-2">
                                            <h6 className="card-title mb-1 text-truncate preview-selected-file-name">
                                                {selectedFile.name}
                                            </h6>
                                            <small className="text-muted">
                                                {formatFileSize(selectedFile.size)} • {selectedFile.type || "Unknown type"}
                                            </small>
                                        </div>
                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onRemove}>
                                            <i className="fas fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p className="tw:!m-0 tw:!text-[14px] tw:!text-[#282828] tw:!font-[400]">
                            {desc}
                        </p>
                    )}
                </div>
                <div className="d-flex align-items-center justify-content-center">
                    {isInvalid && (
                        <p className="text-danger">
                            {invalidMessage}
                        </p>
                    )}
                </div>
                <div className="d-flex align-items-center justify-content-center">
                    <button
                        type="button"
                        className="btn tw:!w-full tw:md:!w-1/4 tw:!py-3 tw:!mt-3 rounded tw:!bg-[#FFFFFF] tw:!border-[1px] tw:!border-[#8D8D8D] tw:!text-[14px] tw:!text-[#4A4A4A] tw:!font-[400]"
                        onClick={chooseFileHandler}
                    >
                        {selectedFile ? (
                            <>
                                <i className="fas fa-sync-alt me-2" aria-hidden="true"></i>
                                Replace File
                            </>
                        ) : (
                            buttonLabel
                        )}
                    </button>
                    <input
                        type="file"
                        name={name}
                        ref={innerRef}
                        id={id}
                        className="d-none"
                        onChange={onChange}
                        accept={accept}
                    />
                </div>
            </div>
        </div >
    )
}
